import React from 'react';
import { TrendingUp, FileText, Clock, AlertTriangle } from 'lucide-react';
import { DashboardCard } from './DashboardCard';

const stats = [
  {
    title: 'Active Bids',
    value: '12',
    change: { value: '+2.5%', type: 'positive' as const },
    description: 'Current proposals in progress',
    progress: 75,
    icon: TrendingUp,
    link: '/proposals?status=active',
  },
  {
    title: 'Open Contracts',
    value: '64',
    change: { value: '+21.3%', type: 'positive' as const },
    description: 'Available opportunities',
    progress: 45,
    icon: FileText,
    link: '/contracts?status=open',
  },
  {
    title: 'Pending Reviews',
    value: '4',
    change: { value: '-8%', type: 'negative' as const },
    description: 'Awaiting internal review',
    progress: 60,
    icon: Clock,
    link: '/proposals?status=review',
  },
  {
    title: 'Compliance Alerts',
    value: '2',
    change: { value: '-3', type: 'negative' as const },
    description: 'Require immediate attention',
    progress: 90,
    icon: AlertTriangle,
    link: '/compliance',
  },
];

export function DashboardStats() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <DashboardCard key={stat.title} {...stat} />
      ))}
    </div>
  );
}